import React from "react";
import { SliderProps as BaseSliderProps } from "@silversea-ssc/ui-components-react";
import * as styles from "./LastSeenProducts.module.scss";
import Slider, { SliderSlide } from "components/Slider";
import { useIsTabletOrDesktop } from "src/utils/useIsTabletOrDesktop";
import { LastSeenProductsResult } from "components/LastSeenProducts/useLastSeenProducts";
import LastSeenProductCard, {
  CardBackgroundColor
} from "./LastSeenProductCard";
import ErrorBoundary from "components/ErrorBoundary";
import { useLingui } from "@lingui/react/macro";

type SliderProps = Pick<BaseSliderProps, "hideNextSlideGroup">;

type Props = {
  slider?: SliderProps;
  cardBackgroundColor?: CardBackgroundColor;
} & Omit<LastSeenProductsResult, "hasLastSeenProducts">;

const LastSeenProducts: React.FC<Props> = ({
  slider = {},
  cardBackgroundColor,
  lastSeenProducts,
  deleteProduct
}) => {
  const { t } = useLingui();
  const title = t`Continue where you left off to secure your cruise`;

  const isTabletOrDesktop = useIsTabletOrDesktop();

  if (lastSeenProducts.length === 0) return null;

  return (
    <ErrorBoundary>
      <div>
        <h3 className={styles.sectionTitle}>{title}</h3>
        <Slider
          variant={isTabletOrDesktop ? "inline" : "normal"}
          data-content-name="last_seen_products_slider"
          {...slider}
        >
          {lastSeenProducts.map(([lastSeenProduct, content]) => (
            <SliderSlide key={content.cruiseCode}>
              <LastSeenProductCard
                backgroundColor={cardBackgroundColor}
                lastSeenProduct={lastSeenProduct}
                content={content}
                onDelete={deleteProduct}
              />
            </SliderSlide>
          ))}
        </Slider>
      </div>
    </ErrorBoundary>
  );
};

export default LastSeenProducts;
